import initialState from '../../data/search';
import ActionTypes from '../constants/action-types';

const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_SEARCH_USERS:
            if (state.users && state.users.length > 0) {
                return {
                    ...state,
                    users: [...state.users, ...action.payload]
                };
            }
            return {
                ...state,
                users: action.payload
            };
        case ActionTypes.SET_SEARCH_KEYWORD:
            return {
                ...state,
                keyword: action.payload
            };
        case ActionTypes.RESET_SEARCH:
            return {
                ...state,
                users: []
            };
        case ActionTypes.SET_SEARCH_BUSY:
            return {
                ...state,
                busy: action.payload
            };
        case ActionTypes.SET_SEARCH_TYPE:
            return {
                ...state,
                type: action.payload
            };
        case ActionTypes.SET_SEARCH_HAS_MORE:
            return {
                ...state,
                hasMore: action.payload
            };
        case ActionTypes.RESET_SEARCH_RESULT:
            return {
                ...state,
                users: []
            };

        default: return state;
    }
};

export default searchReducer;
